module.exports = __webpack_public_path__ + "img/qu_br.d2542d9.jpg";